import { NgModule } from '@angular/core';

import { UserAdminRoutingModule } from './user-admin-routing.module';

@NgModule({
  imports: [UserAdminRoutingModule],
})
export class UserAdminModule {}
